import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    paint: { id: 'lblIconPaint', defaultMessage: 'Paint' },
});

const PaintIcon = React.memo(function PaintIcon(props: TPaintIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.paint)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0531 11.4141L16.435 11.7961L16.2311 12H3.50317L10.0711 5.43211L16.0531 11.4141ZM9.01041 4.37145L7.41929 2.78033C7.1264 2.48744 7.1264 2.01256 7.41929 1.71967C7.71219 1.42678 8.18706 1.42678 8.47995 1.71967L11.1317 4.37145L17.1137 10.3535L17.1144 10.3542L17.4957 10.7354C18.0815 11.3212 18.0815 12.2709 17.4957 12.8567L10.4246 19.9278C9.83884 20.5136 8.88909 20.5136 8.3033 19.9278L1.93934 13.5638C1.35355 12.978 1.35355 12.0283 1.93934 11.4425L9.01041 4.37145ZM18.7086 14.1022C18.6147 13.9145 18.3468 13.9145 18.2529 14.1022L16.6565 17.2949C15.9785 18.651 16.9646 20.2465 18.4807 20.2465C19.9969 20.2465 20.983 18.651 20.3049 17.2949L18.7086 14.1022Z"
            />
        </IconBase>
    );
});

export default PaintIcon;

// #region Types

export type TPaintIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <PaintIcon /> : { ...IconBaseExample, render: PaintIcon };

// #endregion
